import { useData, useDataAuth } from "../../runtime/provider";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { captureException } from "@utils/captureException";
import { cdnKeyQueryOptions } from "./useCDNKey/queryFunctions";
export {
  USER_GETCDNKEY_QUERY_KEY,
  getCDNKeyQueryState,
  fetchCDNKey,
  getCDNKeyFromCache,
} from "./useCDNKey/queryFunctions";

export const useCDNKey = () => {
  const data = useData();
  const enabled = !!useDataAuth().firebaseUser;

  // Short-lived signed token. `staleTime: 0` keeps the live behavior — we
  // always refetch when the consumer mounts. Durable cache is a fallback
  // only: if the network is down on cold-start, the previously stored key
  // can keep video/audio loading until refresh succeeds.
  const query = useQuery({
    ...cdnKeyQueryOptions(data),
    enabled,
  });

  useEffect(() => {
    if (!query.data) return;
    if (dayjs(query.data?.expiry).isBefore(dayjs().add(1, "day"))) {
      console.log("::useCDNKey - refetching CDN key");
      query.refetch().catch((error) => {
        captureException(error, {
          channel: "breadcrumb",
          area: "media",
          operation: "refetch-cdn-key",
        });
      });
    }
  }, [query.data]);

  return query;
};
